import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  get_shortDisplayNamenwyz2dxtvf5g as get_shortDisplayName,
  HasDisplayName3s4kfsms5h38b as HasDisplayName,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ContractorPaymentInfo1nscg9rquslpg as ContractorPaymentInfo } from './ContractorPaymentInfo.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { MemberRole_Manager_getInstance3dbaoot8q9evq as MemberRole_Manager_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import {
  title1nssp3ryhwuqj as title,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
} from '../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  Companion_getInstance33aui7uk8ap15 as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { OuterTabBar_getInstance2g83ti7eoew9h as OuterTabBar_getInstance } from '../../theming/tabs.mjs';
import { get_atStart2tgdnaxgj04ln as get_atStart } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { RadioToggleButton6jdt9lqh3p8p as RadioToggleButton } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/RadioToggleButton.commonHtml.mjs';
import { specCenteredText1zemopd0g3rsf as specCenteredText } from '../../theming/buttons.mjs';
import { equalTo2dio0vrcsd3je as equalTo } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_viewIsWide3s4g60a9e0192 as get_viewIsWide } from '../../components/nav/crowpay.mjs';
import {
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  render2bonfr4ls49sc as render,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.gjh_1.f2();
}
function ContractorPayments$Section$Companion$_anonymous__4773e4() {
  return createSimpleEnumSerializer('com.crowpay.views.screens.contractor.ContractorPayments.Section', values());
}
var Section_NewAvailableFunds_instance;
var Section_Payments_instance;
var Section_TransferHistory_instance;
var Section_BillingHistory_instance;
function values() {
  return [Section_NewAvailableFunds_getInstance(), Section_Payments_getInstance(), Section_TransferHistory_getInstance(), Section_BillingHistory_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.gjh_1 = lazy(tmp_0, ContractorPayments$Section$Companion$_anonymous__4773e4);
      }
      m2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      h1c(typeParamsSerializers) {
        return this.m2a();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  Section_initEntries();
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var Section_entriesInitialized;
function Section_initEntries() {
  if (Section_entriesInitialized)
    return Unit_instance;
  Section_entriesInitialized = true;
  Section_NewAvailableFunds_instance = Section().kjh('NewAvailableFunds', 0, 'New Available Funds');
  Section_Payments_instance = Section().kjh('Payments', 1, 'Payment History');
  Section_TransferHistory_instance = Section().kjh('TransferHistory', 2, 'Transfer History');
  Section_BillingHistory_instance = Section().kjh('BillingHistory', 3, 'Billing History');
  Companion_getInstance_0();
}
var $ENTRIES;
var SectionClass;
function Section() {
  if (SectionClass === VOID) {
    class $ extends Enum() {
      static kjh(name, ordinal, displayName) {
        var $this = this.c4(name, ordinal);
        $this.jjh_1 = displayName;
        return $this;
      }
      g90() {
        return this.jjh_1;
      }
    }
    protoOf($).f90 = get_shortDisplayName;
    initMetadataForClass($, 'Section', VOID, VOID, [HasDisplayName(), Enum()], VOID, VOID, {0: Companion_getInstance_0});
    SectionClass = $;
  }
  return SectionClass;
}
function ContractorPayments$renderMainContent$lambda$lambda($next, this$0) {
  return ($this$swap) => {
    var tmp;
    switch ($next.b4_1) {
      case 0:
        tmp = this$0.djh($this$swap);
        break;
      case 1:
        tmp = this$0.ejh($this$swap);
        break;
      case 2:
        tmp = this$0.fjh($this$swap);
        break;
      case 3:
        tmp = this$0.jjf($this$swap);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
}
function Section_NewAvailableFunds_getInstance() {
  Section_initEntries();
  return Section_NewAvailableFunds_instance;
}
function Section_Payments_getInstance() {
  Section_initEntries();
  return Section_Payments_instance;
}
function Section_TransferHistory_getInstance() {
  Section_initEntries();
  return Section_TransferHistory_instance;
}
function Section_BillingHistory_getInstance() {
  Section_initEntries();
  return Section_BillingHistory_instance;
}
var ContractorPaymentsClass;
function ContractorPayments() {
  if (ContractorPaymentsClass === VOID) {
    class $ extends ContractorPaymentInfo() {
      constructor() {
        super();
        this.rev_1 = new (Constant())(_Constant___init__impl__v45mub('Payments'));
        this.sev_1 = MemberRole_Manager_getInstance();
        this.tev_1 = Signal().fak(Section_NewAvailableFunds_getInstance());
      }
      ucv() {
        return this.rev_1;
      }
      bhg() {
        return this.sev_1;
      }
      rhi(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        view.zb8(get_AppDimensions().yg1_1);
        title(view, 'Finances');
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Here\u2019s your financial snapshot: each project draw or release is broken down into gross value, Stoze\u2019s small fee, and the net amount you can collect right now. Simply hit Collect Funds, choose where you want your money, and we\u2019ll handle the rest. Your full payout history lives below.';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.jba(view_0.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_0 = view_0.tb5_1;
        var tmp_1;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_1 = '\xA0';
        } else {
          tmp_1 = content;
        }
        tmp_0.fbu(tmp_1);
        view.fbb(p_0, view_0);
        view.jbb(sizeConstraints(view, VOID, get_rem(16)), this.cjh(view));
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view.pc());
        var tmp0_elvis_lhs_1 = view.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.ebb(p_1, view_1);
        view.fbb(p_1, view_1);
        if (get_viewIsWide(view)) {
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_2 = view.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
          view.ebb(p_2, view_2);
          view_2.xbm(true);
          view_2.zb8(view_2.kba().db1(OuterTabBar_getInstance()).eb1_1.hb0_1);
          var tmp_2 = view_2.ibb(get_atStart(view_2), view_2.hbb(OuterTabBar_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_3 = new (RowOrCol())(view_2.pc());
          var tmp0_elvis_lhs_3 = view_2.cbb_1;
          var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
          view_2.ebb(p_3, view_3);
          view_3.xbm(false);
          var _iterator__ex2g4s = get_entries().m1();
          while (_iterator__ex2g4s.n1()) {
            var sec = _iterator__ex2g4s.o1();
            // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
            var tmp_3 = view_3.hbb(ButtonSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.radioToggleButton' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_4 = new (RadioToggleButton())(view_3.pc());
            var tmp0_elvis_lhs_4 = view_3.cbb_1;
            var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
            view_3.ebb(p_4, view_4);
            specCenteredText(view_4, sec.jjh_1);
            view_4.xah(view_4.zc8_1, equalTo(this.tev_1, sec));
            view_3.fbb(p_4, view_4);
            view_3.jbb(tmp_3, view_4);
          }
          view_2.fbb(p_3, view_3);
          view_2.jbb(tmp_2, view_3);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_5 = new (SwapView())(view_2.pc());
          var tmp0_elvis_lhs_5 = view_2.cbb_1;
          var p_5 = tmp0_elvis_lhs_5 == null ? view_2 : tmp0_elvis_lhs_5;
          view_2.ebb(p_5, view_5);
          var prev = {_v: null};
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_0 = view_5;
          var queue = ArrayList().w();
          var alreadySwapping = {_v: false};
          reactiveScope(this_0, ($this$reactiveScope) => {
            var c = $this$reactiveScope.baj(this.tev_1);
            queue.v(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.i1()) {
                break $l$loop;
              }
              var next = queue.z3(0);
              try {
                var tmp$ret$19;
                $l$block: {
                  if (prev._v == null) {
                    prev._v = next;
                    tmp$ret$19 = Companion_getInstance().vax_1;
                    break $l$block;
                  }
                  tmp$ret$19 = next.d4(prev._v) > 0 ? Companion_getInstance().rax_1 : Companion_getInstance().sax_1;
                }
                var tmp_0 = tmp$ret$19;
                this_0.rci(tmp_0, ContractorPayments$renderMainContent$lambda$lambda(next, this));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().vd('Failed to render ' + toString(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          view_2.fbb(p_5, view_5);
          view.fbb(p_2, view_2);
        }
        _this__u8e3s4.fbb(p, view);
        _this__u8e3s4.jbb(tmp, view);
      }
    }
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    protoOf($).ud6 = render;
    initMetadataForClass($, 'ContractorPayments', ContractorPayments, VOID, [ContractorPage(), ContractorPaymentInfo()], [0, 1]);
    ContractorPaymentsClass = $;
  }
  return ContractorPaymentsClass;
}
//region block: exports
export {
  Section as Section14eh2zqy1zxno,
  ContractorPayments as ContractorPayments3j77ex8prycqi,
};
//endregion

//# sourceMappingURL=ContractorPayments.mjs.map
